import initI18n from '@repo/i18n/tools'
import { getI18nLangFromLandingStorage } from '@repo/common-utils/utils/landingI18nLang'

export const i18n = initI18n({
  getLang: getI18nLangFromLandingStorage,
  zhLocale: {
    确定: '确定',
    登录安全提醒: '登录安全提醒',
    '您的账号已在其他地方登录，请确认是否为本人操作。如非本人操作，请重新登录当前账号或':
      '您的账号已在其他地方登录，请确认是否为本人操作。如非本人操作，请重新登录当前账号或致电',
    联系客服: '联系复星财富客服。',
  },
  tcLocale: {
    确定: '確定',
    登录安全提醒: '登錄安全提醒',
    '您的账号已在其他地方登录，请确认是否为本人操作。如非本人操作，请重新登录当前账号或':
      '您的賬號已在其他地方登錄，請確認是否為本人操作。如非本人操作，請重新登錄當前賬號或致電',
    联系客服: '聯繫復星財富客服。',
  },
  enLocale: {
    确定: 'Confirm',
    登录安全提醒: 'Login Security Alert',
    '您的账号已在其他地方登录，请确认是否为本人操作。如非本人操作，请重新登录当前账号或':
      'Your account has been logged in elsewhere. Please confirm if this is your own operation. If not, please log in to your current account again or call',
    联系客服: 'contact Fosun Wealth customer service.',
  },
})
